// Naviagtion.js

var $ = require('jquery');
var isSticky = false;


$(document).ready(function() {

  // Close Menu on click on menu item
  $('.mobile__middle li').on('click', function(){
    $('.site-header').removeClass('-active');
    $('body').removeClass("-has-nav");
  });
  
  // Menu Toggle
  $('.site-header .js-toggle').on('click', function(){
    $('.site-header').toggleClass('-active');
    $('body').toggleClass("-has-nav");
  });

  stickyMenu();
})

// Menu Toggle
$(window).on('resize', function() {
  if(window.innerWidth >= 991) {
    $(".site-header").removeClass("-active");
    $('body').removeClass("-has-nav");
    $('.site-header__primary').addClass("-sticky");
  } else {
    $('.site-header__primary').removeClass("-sticky");
  }
})

// Sticky Menu
$(window).on('resize scroll', function() {
  stickyMenu();
})



// Functions - - - - - - - - - - - - - - - - - - -
// - - - - - - - - - - - - - - - - - - - - - - - -


// - - - Sticky Primary Menu - - -
function stickyMenu() {
  var primaryMenu = $(".js-site-header__primary");

  if (window.innerWidth >= 991) {
    if(primaryMenu.length != 0) {

      if($(window).scrollTop() >= 130) {
        if(!isSticky){
          primaryMenu.addClass("-sticky");
          isSticky = true;
        }
      } 
      if($(window).scrollTop() < 130) {
        if(isSticky){
          primaryMenu.removeClass("-sticky");
          isSticky = false;
        }
      }
    }
  }
}